import React from 'react';

import { AlertValue, CurrentValue, DirectionEnumReverse, PriceDetails, ValueTargets } from '../../interfaces';
import PeriodStatus from './PeriodStatus';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import { formatDate } from '../../utils';

const isPriceDetails = (value: any): value is Partial<Record<('sell' | 'buy'), PriceDetails>> => {
  return (value?.buy && !Array.isArray(value?.buy)) || (value?.sell && !Array.isArray(value?.sell));
}

const objectStatusRow = (data: Partial<ValueTargets>) => {
  if (!data) return <></>;

  const detailRow = (details: PriceDetails) => {
    return Object.entries(details).map(([key, value], idx) => (
      <ul key={key} style={{ margin: 0, listStyle: 'none', padding: 0 }}>
        <li key={'details-' + idx} style={{ margin: 0 }}>
          {key}:{' '}
          {Object.entries(value).map(([num, ids], idx) => (
            <span key={`detail-${idx}`}>
              {' '}
              {num}: {ids.toString()} |
            </span>
          ))}
        </li>
      </ul>
    ));
  };

  const mapRows = (value: any) => {
    if (isPriceDetails(value)) {
      return (
        <ul key={'values'} style={{ margin: 0, padding: 0 }} >
          {value?.buy && <li>{detailRow(value?.buy)}</li>}
          {value?.sell && <li>{detailRow(value?.sell)}</li>}
        </ul>
      )
    } else {
      return <li>{detailRow(value)}</li>
    }
  }

  return (
    <ul style={{ margin: 0 }}>
      {Object.entries(data).map(([key, value], idx) => (
        <li key={'details-' + idx}>
          {key}: {value && mapRows(value)}
        </li>
      ))}
    </ul>
  );
};

export const JonoStatusRow = ({ data }: { data: number[] }) => {
  if (!data) return <></>;
  return <>{data.map((value, idx) => (
    <span key={'jono-' + idx}>{value} , </span>
  ))}</>
};

export const CurrentStatusDataRows = ({ data }: { data: AlertValue }) => {
  const mapValue = (key: string, value: any) => {
    if (key === 'period') {
      return <PeriodStatus period={value} />;
    } else if (key === 'jono') {
        return <JonoStatusRow data={value} />;
    } else if (typeof value === 'boolean') {
      return value?.toString();
    } else if (key === 'updated') {
      return formatDate(value);
    } else if (typeof value === 'number') {
      return value.toFixed(5);
    } else if (typeof value === 'object') {
      return objectStatusRow(value);
    } else {
      return value;
    }
  };

  const rows = Object.entries(data).map(([key, value], idx) => ({
    param: key,
    value: mapValue(key, value)
  }));

  return (
    <>
      {rows.map((row, idx) => (
        <TableRow key={idx}>
          <TableCell>{row.param}</TableCell>
          <TableCell>{row.value}</TableCell>
        </TableRow>
      ))}
    </>
  );
};

const CurrentStatus = ({ row }: { row: CurrentValue }) => {
  console.log(row)

  const [direction, wave, tracer, timma, bvol, half, vahti, vola, rendi, jono] = row.directions
  const [current, current_ask, current_bid, x] = row.current
  const [up, base_up, up_ask, up_bid] = row.up_base_ask_bid
  const [down, base_down, down_ask, down_bid] = row.down_base_ask_bid
  return (
    <>
      <TableCell>{row.online?.toString()}</TableCell>
      <TableCell>{DirectionEnumReverse[direction as keyof typeof DirectionEnumReverse] ?? `${direction * 100}%`}</TableCell>
      <TableCell>{DirectionEnumReverse[wave as keyof typeof DirectionEnumReverse]}</TableCell>
      <TableCell>{DirectionEnumReverse[tracer as keyof typeof DirectionEnumReverse]}</TableCell>
      <TableCell>{DirectionEnumReverse[timma as keyof typeof DirectionEnumReverse]}</TableCell>
      <TableCell>{DirectionEnumReverse[bvol as keyof typeof DirectionEnumReverse]}</TableCell>
      <TableCell>{DirectionEnumReverse[half as keyof typeof DirectionEnumReverse]}</TableCell>
      <TableCell>{DirectionEnumReverse[vahti as keyof typeof DirectionEnumReverse]}</TableCell>
      <TableCell>{DirectionEnumReverse[vola as keyof typeof DirectionEnumReverse]}</TableCell>
      <TableCell>{DirectionEnumReverse[rendi as keyof typeof DirectionEnumReverse]}</TableCell>
      <TableCell>{DirectionEnumReverse[jono as keyof typeof DirectionEnumReverse]}</TableCell>
      <TableCell>{current?.toFixed(5)}</TableCell>
      <TableCell>{current_ask?.toFixed(5)}</TableCell>
      <TableCell>{current_bid?.toFixed(5)}</TableCell>
      <TableCell>{x?.toFixed(5)}</TableCell>
      <TableCell>{up?.toFixed(5)}</TableCell>
      <TableCell>{up_ask?.toFixed(5)}</TableCell>
      <TableCell>{up_bid?.toFixed(5)}</TableCell>
      <TableCell>{down?.toFixed(5)}</TableCell>
      <TableCell>{down_ask?.toFixed(5)}</TableCell>
      <TableCell>{down_bid?.toFixed(5)}</TableCell>
      <TableCell>{formatDate(row.updated)}</TableCell>
      <TableCell>{base_down?.toFixed(5)}</TableCell>
      <TableCell>{base_up?.toFixed(5)}</TableCell>
      <TableCell>{objectStatusRow(row.value_down)}</TableCell>
      <TableCell>{objectStatusRow(row.value_up)}</TableCell>
    </>
  );
};
export default CurrentStatus;

export const CurrentStatusHeader = () => {
  return (
    <>
      <TableCell>Online</TableCell>
      <TableCell>Direction</TableCell>
      <TableCell>Wave</TableCell>
      <TableCell>Tracer</TableCell>
      <TableCell>Timma</TableCell>
      <TableCell>Bvol</TableCell>
      <TableCell>Half</TableCell>
      <TableCell>Vahti</TableCell>
      <TableCell>Vola</TableCell>
      <TableCell>Rendi</TableCell>
      <TableCell>Jono</TableCell>
      <TableCell>Current</TableCell>
      <TableCell>Current ask</TableCell>
      <TableCell>Current bid</TableCell>
      <TableCell>X-Ema</TableCell>
      <TableCell>Up</TableCell>
      <TableCell>Up ask</TableCell>
      <TableCell>Up bid</TableCell>
      <TableCell>Down</TableCell>
      <TableCell>Down ask</TableCell>
      <TableCell>Down bid</TableCell>
      <TableCell>Updated</TableCell>
      <TableCell>Base Down</TableCell>
      <TableCell>Base Up</TableCell>
      <TableCell>Values Down</TableCell>
      <TableCell>Values Up</TableCell>
    </>
  );
};
